


























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Project } from '@/model/Project'
import { User } from '@/model/User'

@Component({})
export default class PricingChoiceComp extends Vue {
  @Prop() project!: Project
  @Prop() user!: User

  @Watch('project', { immediate: true })
  onProjectChanges(current: any, old: any) {
    if (old && old.siret === current.siret) return
    if (this.project.siret) {
      this.updateUserField('creation', false)
    } else {
      console.log(this.user.creation)
      this.updateUserField('creation', !!this.user.creation)
    }
  }

  updateProjectField(field: keyof Project, value: any) {
    this.$emit('updateProject', { field, value })
  }

  updateUserField(field: keyof User, value: any) {
    this.$emit('updateUser', { field, value })
  }
}
